const routeMapping = {
    dashboard_default: 'dashboard-v2',
    reporting_adwords: 'reporting-google-v2',
    reporting_adwords_campaigns: 'reporting-adwords-campaigns-v2',
    reporting_adwords_adgroups: 'reporting-adwords-adgroups-v2',
    reporting_adwords_ads: 'reporting-adwords-ads-v2',
    reporting_adwords_keywords: 'reporting-adwords-keywords-v2',
    reporting_adwords_conversions: 'reporting-adwords-conversions-v2',
    reporting_facebook: 'reporting-facebook-v2',
    reporting_facebook_campaigns: 'reporting-facebook-campaigns-v2',
    reporting_facebook_adsets: 'reporting-facebook-adsets-v2',
    reporting_facebook_ads: 'reporting-facebook-ads-v2',
    reporting_facebook_demographics: 'reporting-facebook-demographics-v2',
    reporting_attribution: 'reporting-attribution-v2',
    'appointments-reports': 'appointments-reports-v2',
    call_stats: 'call-stats-v2',
    agent_reporting: 'agent-reporting-v2',
    dashboard: 'dashboard-v2',
    location_launchpad: 'location-launchpad-v2',
    appointments: 'appointments-v2',
    'calendar-v2': 'calendars-page-v2',
    conversations: 'conversations-id-v2',
    reminders: 'reminders-v2',
    opportunities: 'opportunities-v2',
    chat_widget_settings: 'chat-widget-settings-v2',
    analysis: 'analysis-v2',
    bulk_imports_log: 'bulk-imports-log-v2',
    bulk_actions_log: 'bulk-actions-log-v2',
    customer_bulk_actions: 'bulk-imports-log-v2',
    bulk_actions: 'bulk-actions-log-v2',
    contacts: 'contacts-contacts-v2',
    manual_actions: 'manual-actions-v2',
    customers_contact: 'smart-list-v2',
    smart_list: 'smart-list-v2',
    import_filter: 'import_filter-v2',
    business_name: 'business_name-v2',
    leads: 'leads-v2',
    contact_detail: 'contact_detail-v2',
    contact_restore: 'contact_restore-v2',
    social_media: 'social_media-v2',
    membership: '',
    all_funnels: 'funnels-page-v2',
    websites_funnels: 'websites-funnels-v2',
    fav_funnels: 'fav_funnels-v2',
    recent_funnels: 'recent_funnels-v2',
    archived_funnels: 'archived_funnels-v2',
    funnels_detail: 'funnels-detail-v2',
    funnel_steps: 'funnel-step-overview-v2',
    funnel_step_overview: 'funnel-step-overview-v2',
    funnel_step_automation: 'funnel-step-automation-v2',
    funnel_step_publish: 'funnel-step-publish-v2',
    funnel_step_product: 'funnel-step-product-v2',
    funnel_step_products: 'funnel-step-products-v2',
    funnel_step_product_v2: 'funnel-step-product-v2-create',
    funnel_step_product_v2_edit: 'funnel-step-product-v2-edit',
    funnel_stats: 'funnel-stats-v2',
    funnel_sales: 'funnel-sales-v2',
    wordpress: 'wordpress-v2',
    wordpress_dashboard: 'wordpress_dashboard-v2',
    wordpress_advance: 'wordpress_advance-v2',
    wordpress_user_management: 'wordpress_user_management-v2',
    wordpress_plugin_management: 'wordpress_plugin_management-v2',
    wordpress_theme_management: 'wordpress_theme_management-v2',
    wordpress_backup_management: 'wordpress_backup_management-v2',
    funnel_settings: 'funnel-settings-v2',
    websites_detail: 'websites-detail-v2',
    website_pages: 'website-pages-v2',
    website_stats: 'website-stats-v2',
    website_sales: 'website-sales-v2',
    website_settings: 'website-settings-v2',
    website_products: 'website-products-v2',
    website_step_products: 'website-step-products-v2',
    funnel_templates_category: 'funnel-templates-category',
    website_templates_category: 'website-templates-category',
    funnel_templates_category_detail: 'funnel-templates-category-detail',
    website_templates_category_detail: 'website-templates-category-detail',
    funnel_templates_detail: 'funnel-templates-detail',
    website_templates_detail: 'website-templates-detail',
    triggers: 'triggers-v2',
    reputation: 'reputation-v2',
    reputation_overview: 'reputation-overview-v2',
    reputation_review_requests: 'reputation-review-requests-v2',
    reputation_reviews: 'reputation-reviews-v2',
    reputation_settings: 'settings-reputation-v2',
    reputation_listing: 'reputation_listing-v2',
    newWorkflow: 'newWorkflows-v2',
    workflows: 'workflows-v2',
    triggers_detail: 'triggers_detail-v2',
    customer_acquisition: 'campaigns-v2',
    campaign_edit: 'campaign_edit-v2',
    campaign_detail: 'campaign_detail-v2',
    campaign_accounts_list: 'campaign_accounts_list-v2',
    campaign_activity: 'campaign_activity-v2',
    bulk_requests: 'bulk_requests-v2',
    links: 'triggers-links-v2',
    form_builder: 'form-builder-main-v2',
    form_builder_main: 'form-builder-main-v2',
    form_builder_analyze: 'form-builder-analyze-v2',
    form_builder_submissions: 'form-builder-submissions-v2',
    email_builder_list: 'email_builder_list-v2',
    email_builder_dashboard: 'email_builder_dashboard-v2',
    emails_home: 'emails_home-v2',
    'social-planner': 'social-planner-v2',
    form_builder_manage: 'form-builder-manage',
    form_builder_manage_v2: 'form-builder-manage-v2',
    survey_builder_manage_v2: 'survey-builder-manage-v2',
    form_builder_manage_old: 'form_builder_manage_old-v2',
    form_builder_integrate: 'form_builder_integrate-v2',
    survey_builder: 'survey-builder-main-v2',
    survey_builder_main: 'survey-builder-main-v2',
    survey_builder_analyze: 'survey-builder-analyze-v2',
    survey_builder_submissions: 'survey-builder-submissions-v2',
    survey_manage: 'survey-manage',
    survey_integrate: 'survey_integrate-v2',
    text_templates: 'conversations-sms-templates-v2',
    jotbox_form: 'jotbox_form-v2',
    jotbox_survey: 'jotbox_survey-v2',
    'log-viewer': 'log-viewer-v2',
    'log-viewer-detail': 'log-viewer-detail-v2',
    notifications: 'notifications-v2',
    notificationslist: 'notificationslist-v2',
    location_custom_menu_link: 'location-custom-menu-link-v2',
    facebook_page_select: '',
    google_location_select: '',
    dr_chrono_office_select: '',
    settings: 'profile-v2',
    profile: 'profile-v2',
    company_settings: 'company-settings-v2',
    location_billing: 'location_billing-v2',
    location_wallet_transactions: 'location_wallet_transactions-v2',
    email_settings: 'settings-reputation-v2',
    sms_settings: 'settings-reputation-v2',
    no_show_sms_settings: 'no_show_sms_settings-v2',
    birthday_sms_settings: 'birthday_sms_settings-v2',
    integrations_settings: 'integrations-settings-v2',
    social_posting: 'social_posting-v2',
    review_widgets: 'settings-reputation-v2',
    review_popup: 'review_popup-v2',
    pipeline_settings: 'pipeline-settings-v2',
    payment_settings: 'payment_settings',
    chat_widget: 'chat_widget-v2',
    appointment_widget: 'appointment-widget-2',
    phone_number: 'phone-number-v2',
    template_settings: 'template-settings-v2',
    location_team_management: 'team-v2',
    location_teams_management: 'teams-v2',
    custom_fields_settings: 'custom-fields-settings-v2',
    custom_values_settings: 'custom-values-settings-v2',
    custom_emails_settings: 'custom-emails-settings-v2',
    calendar_settings: 'calendar-settings-v2',
    loc_mail_gun_settings: 'loc_mail_gun_settings-v2',
    facebook_settings: 'facebook_settings-v2',
    tiktok_settings: 'tiktok_settings-v2',
    domain_settings: 'domain-settings-v2',
    tags_settings: 'tags-settings-v2',
    smtp_service: 'smtp-service-v2',
    eliza_faq: 'eliza-faq-v2',
    'product-create': 'product-create-v2',
    'import-stripe-product': 'import-stripe-product-v2',
    'product-details': 'product-details-v2',
    'product-edit': 'product-edit-v2',
    'product-list': 'product-list-v2',
    transactions: 'transactions-v2',
    'payment-integrations': 'payment-integrations-v2',
    'payment-integrations-callback': 'payment-integrations-callback-v2',
    settings_reputation: 'settings-reputation-v2',
    settings_reputation_settings: 'settings-reputation-v2',
    website_step_product_v2: 'website-step-product-v2',
    website_step_product_v2_edit: 'website-step-product-v2-edit',
    'audit-location': 'audit-location-v2',
    template_library_admin: 'template-library-admin'
}

export default routeMapping;
